import "metabase/plugins/builtin/auth/password";
import "metabase/plugins/builtin/auth/google";
import "metabase/plugins/builtin/auth/ldap";
